module.exports = __webpack_public_path__ + "static/img/coupon-bg-active.e04f0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/service/coupon-bg-active.png
// module id = op2z
// module chunks = 86